import { config } from "@financial-advisory/config";
import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQuery } from "./baseQuery";

export const orchestrationApi = createApi({
  reducerPath: "orchestrationApi",
  baseQuery: createBaseQuery(config.API_BASE_URL),
  endpoints: () => ({}),
  tagTypes: [""],
});
